import React from 'react';
import { InputFields } from './components/InputFields';
import style from './CreationForm.module.scss';

export const CreationForm: React.FC = () => {
	return (
		<div className={style.container} data-test="CreationForm">
			<InputFields />
		</div>
	);
};
